import { Component, Input } from '@angular/core';
import { IonicPage, NavController, NavParams, ModalController, LoadingController, ToastController, ViewController } from 'ionic-angular';
import { login, User, SharedService, MessageService, SessionService, ConfigService, Status, } from 'baseline-lib';
import { WebviewpagesPage } from '../webviewpages/webviewpages';
import { Global } from '../../../global/global';
import { CustomToast } from '../services/custom-toast';
import { TranslateService } from '@ngx-translate/core';
import { ForgotPasswordModalPage } from '../forgot-password-modal/forgot-password-modal';
declare var grecaptcha: any;


/**
 * Generated class for the LoginModalPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-login-modal',
  templateUrl: 'login-modal.html',
})
export class LoginModalPage {
  loginModel: login;
  public authUser: User; 
  unautherisedStatus: any;
  httplink : string;
  
  
  constructor(public navCtrl : NavController, public navParams : NavParams,
    public _sharedService : SharedService,public _messageService: MessageService,
    private _sessionService : SessionService,private _configService : ConfigService,
    public translate : TranslateService,public viewCtrl : ViewController, 
    private modalCtrl : ModalController, private loadingCtrl : LoadingController,
    private globalData : Global, private toast: CustomToast) {
  }

  ngOnInit() {
    // this.loginModel = new login('', '');  
    this.loginModel = new login('', '', this._configService.isplayerLogin(), '');

    if(this._configService.isplayerLogin()) {
      if(this._configService.getPlayerId() && this._configService.getPlayerPswd()) {
        this.loginModel.userId = this._configService.getPlayerId();
        this.loginModel.userPWD = this._configService.getPlayerPswd();
      }
    }
  }

  login()
  {
    console.log('Login Clicked');
    
    if(this.loginModel.captcha) {
      const response = grecaptcha.getResponse();
      if (response.length === 0) {        
        this.translate.get('Recaptcha not verified').subscribe(
          value => 
          {
            this.toast.showError(value);
          });
          return false;
      }          
      this.loginModel.recaptchaResponse = response;
    } 
    
    if(!this.loginModel.userId) {
      this.translate.get('Username is required').subscribe(
        value => 
        {
          this.toast.showError(value);
        });

      return false;
    } else if(!this.loginModel.userPWD){
      this.translate.get('Password is required').subscribe(
        value => 
        {
          this.toast.showError(value);
        });

      return false;
    }else
    {
      const loader = this.loadingCtrl.create({
        content: "Please Wait",
      });
  
      loader.present();
      if (this.loginModel) {
        this._messageService.signIn(this.loginModel).
          subscribe(data => {
            
            loader.dismiss();
            if (data.status == Status.ok) 
            {          
                  
              var user = new User();                    
              user.parse(data, this._configService.getAppType(), this._configService.getExcludedWallets());
              this.globalData.authUser = user;
              this.globalData.authUser.gameTypeBalance = user.gameTypeBalance;
              this.globalData.authUser.balance = user.balance;                   
              console.log(this.globalData.authUser.gameTypeBalance);
              if (this.globalData.authUser) {            
                this._sessionService.authUser = this.globalData.authUser;
                this.globalData.isLoggedIn = true;
                localStorage.setItem("authUser",JSON.stringify(this.globalData.authUser));
                localStorage.setItem("loggedIn",this.globalData.isLoggedIn+"");                        
                this.globalData.selectedMenu = this.globalData.selectedMenu;
                this.translate.get('You have Logged in successfully').subscribe(
                  value => 
                  {
                    this.toast.showSuccess(value);
                  });
          
                this.viewCtrl.dismiss();
                this._sharedService.loginSubject.next(true);            
              }
              if(this._configService.isplayerLogin()){
                grecaptcha.reset();
              }

            }else{                      
              this.toast.showError(data.msg);
              return false;
            }
          },
          error => {            
            loader.dismiss();
            if (error.msg) {
              this.unautherisedStatus = error.msg;
            }
            else {
              this.unautherisedStatus = error.message;
            }
            this.toast.showError(this.unautherisedStatus);

            if(this._configService.isplayerLogin()){
              grecaptcha.reset();
            }
          });
        }
      }
  }  

  goBack() {
    this.viewCtrl.dismiss();
  }

  forgotPasswordClicked(){
    this.viewCtrl.dismiss();
    let forgotPswdModal = this.modalCtrl.create(ForgotPasswordModalPage);
    forgotPswdModal.present(); 
  }
   

}



// WEBPACK FOOTER //
// ./src/app/shared/login-modal/login-modal.ts